import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

const OrgScopedLayout = () => {
  //   const { orgId } = useParams();
  useEffect(() => {
    console.log("called...");
  }, []);
  return <Outlet />;
};

export default OrgScopedLayout;
